import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ButtonLoader from '../../Elements/Button/button';
//import '../../../assets/css/siicex-usuario.css';


import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../../constants';
// import {OPTIONS_ACTIVE} from '../../../constants';
// import Error from '../../Error/error';

import {DropDownList} from '../../Elements/Select/dropdown';


export default class add_tipo_recurso extends Component {

    constructor(props) {
        super(props);

        this.state = {
            nNumero: '',
            resource: [],
            response: [],
            error: [],
            key: 0,
            loading : false,
            add: false
          }
    
        this.handleInputChange = this.handleInputChange.bind(this);
      }
    
    

      handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
          
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource[target.name] = value;
            
        this.setState({
            resource: copyResource
        });
    }

    componentDidMount(){
        var key = 0;
        const url = `${API_URL}ResourceTypeUX/${key}`;
        
        axios.get(url).then(response => response.data)
        .then((data) => {
            
            this.setState({ resource: data.result, response: data, error: data.Error });
            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            console.log(error);
            document.querySelector('.loader').classList.add('loader--hide');
            toast.error("¡Error al inicializar!");
        });
    }

    

     handleClickCancel(e) {
        const {history: {push}} = this.props;    
        push('/tipo-recurso');
     }

     callFunctionButton = (event) => {

        this.setState({loading:true});

        var user = JSON.parse(localStorage.getItem("user"));

        const {history: {push}} = this.props;    
        const url = `${API_URL}ResourceTypeUX/`;

        const formData = JSON.stringify(this.state.resource);

        console.log(formData);

        axios.post(
            url, 
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {             
                    console.log(data);
                    
                    if (data.data.isSucess)
                    {
                        toast.success('Recurso registrado correctamente. \n Se redireccionará al listado');
                        setTimeout(() => { push('/tipo-recurso');}, 1000);  
                    } else 
                    {
                        toast.error('Error en el registro');
                        this.setState({loading:false});
                    }
                }
            ).catch((error)=> {
                toast.error('Error no controlado');
                this.setState({loading:false});
            }); 
     }



    render() {

        return ( 
                    <div id="detailBody" className="Site-content" >
                        <div className="loader"></div> 
                        <form id="frmResource" name="frmResource" onSubmit={this.handleClickSubmit} >

                            <input type="hidden" id="dFechaModificacion" name="dFechaModificacion" defaultValue={this.state.resource.dFechaModificacion} />
                            <input type="hidden" id="dFechaPublicacion" name="dFechaPublicacion" defaultValue={this.state.resource.dFechaPublicacion} />
                            <input type="hidden" id="nUsuarioCreacion" name="nUsuarioCreacion" defaultValue={this.state.resource.nUsuarioCreacion} />
                            <input type="hidden" id="nUsuarioModificacion" name="nUsuarioModificacion" defaultValue={this.state.resource.nUsuarioModificacion} />
                            
                            <div hidden={false} id="content-wrapper" className="d-flex flex-column">
                            <div id="content">
                                <div id="Body" className="body-container container-fluid">
                                    <div className="content-option">
                                         <div className="row ">
                                            <div className="col-md-5 ">
                                                <div className="boletin__filters section__margin-bottom">
                                                    <div className="form-group">
                                                        <label htmlFor="nTipoRecursoCodigo"><strong>Código</strong></label>
                                                        <input type="text" readOnly name="nTipoRecursoCodigo" defaultValue={0} onChange={this.handleInputChange} id="nTipoRecursoCodigo" className="form-control text-filter__form-control" placeholder="Código" />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="sDescripcion"><strong>Descripción</strong></label>
                                                        <input type="text" name="sDescripcion" id="sDescripcion" onChange={this.handleInputChange} className="form-control text-filter__form-control" placeholder="Descripción" />
                                                    </div> 
                                                    <div className="form-group">
                                                        <label htmlFor="sCodigo"><strong>Codigo</strong></label>
                                                        <input type="text" name="sCodigo" id="sCodigo" onChange={this.handleInputChange} defaultValue={this.state.resource.sCodigo} className="form-control text-filter__form-control" placeholder="Código" />
                                                    </div>                                                     
                                                    <div className="form-group">
                                                        <label htmlFor="nOrden"><strong>Orden</strong></label>
                                                        <input type="text" name="nOrden" id="nOrden" onChange={this.handleInputChange} className="form-control text-filter__form-control" placeholder="Orden" />
                                                    </div> 
                                                    <div className="form-group">
                                                        <label htmlFor="cEstado"><strong>Estado</strong></label>
                                                        <div className="">
                                                            <DropDownList name="cEstado"  onChange={this.handleInputChange} clave={"R"} id="cEstado"  componente={"Estado"} />
                                                        </div>
                                                    </div>                                                                                                                                                           
                                                    <div className="form-group">
                                                        <label htmlFor="bActivo"><strong>Activo</strong></label>
                                                        <div className="">
                                                            <DropDownList name="bActivo"  onChange={this.handleInputChange} clave={true} id="bActivo" componente={"Activo"} />
                                                        </div>
                                                    </div> 
                                                </div>                                     
                                            </div>
                                            <div className="col-md-7 ">
                                                <div className="">
                                                    <strong><hr/></strong>
                                                    <strong>FECHA DE CREACIÓN:</strong>
                                                    <br/> 
                                                    <strong>CREADO POR</strong> : MIGUEL QUIROZ 
                                                    <br/><br/>
                                                    <strong>FECHA DE MODIFICACIÓN:</strong> 
                                                    <br/> 
                                                    <strong>MODIFICADO POR:</strong> MIGUEL QUIROZ

                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-8">
                                                <button type="button" onClick={(event) => this.handleClickCancel(event)} className="btn btn-default btn-primary__submit">Cancelar</button> 
                                                &nbsp;
                                                <ButtonLoader text="GUARDAR" textProcessing="PROCESANDO..." loading={this.state.loading} callFunctionButton={() => this.callFunctionButton()}></ButtonLoader>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </form>
                    </div>    
                );
    }
}
